export const storeOrdersSelector = (state) => state.storeStore.storeOrders;
export const isGettingStoreOrdersSelector = (state) =>
  state.storeStore.isGettingStoreOrders;
export const currentStoreOrderSelector = (state) =>
  state.storeStore.currentStoreOrder;
export const isUpdatingStoreManagerSelector = (state) =>
  state.storeStore.isUpdatingStoreManager;
export const showManagerFormSelector = (state) =>
  state.storeStore.showManagerForm;
export const isUpdatingStoreOrderSelector = (state) =>
  state.storeStore.isUpdatingStoreOrder;

export const isUpdatingStoreSelector = (state) =>
  state.storeStore.isUpdatingStore;
export const storeVariantsSelector = (state) => state.storeStore.storeVariants;
export const storeManifestSelector = (state) => state.storeStore.manifest;

export const isLoadingMatrixProductsSelector = (state) => state.storeStore.isLoadingMatrixProducts;
export const matrixProductsSelector = (state) => state.storeStore.matrixProducts;
export const errorMatrixProductsSelector = (state) => state.storeStore.errorMatrixProducts;
export const totalPagesProductsSelector = (state) => state.storeStore.totalPagesProducts;

export const loadAddProductOrderSelector = (state) => state.storeStore.loadAddProductOrder;
export const responseAddProductSelector = (state) => state.storeStore.responseAddProduct;
export const errorAddProductOrderSelector = (state) => state.storeStore.errorAddProductOrder;

export const loadStocksByVariantSelector = (state) => state.storeStore.loadStocksByVariant;
export const stocksByVariantSelector = (state) => state.storeStore.stocksByVariant;
export const errorStocksByVariantSelector = (state) => state.storeStore.errorStocksByVariant;

export const reasonsForRefundSelector = (state) => state.storeStore.reasonsForRefund;

export const iVariant1GralSelector = (state) => state.storeStore.iVariant1Gral;
export const iVariant2GralSelector = (state) => state.storeStore.iVariant2Gral;

export const isLoadingProductsToAddSelector = (state) => state.storeStore.isLoadingProductsToAdd;
export const productsToAddSelector = (state) => state.storeStore.productsToAdd;
export const errorProductsToAddSelector = (state) => state.storeStore.errorProductsToAdd;
export const totalPagesProductsToAddSelector = (state) => state.storeStore.totalPagesProductsToAdd;

